import { useAxiosRequest } from "api/axiosRequest"
import { VesselInfo } from "./useFetchVesselInfo"
import { useState } from "react"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { toast } from "react-toastify"

export interface VesselInfoByList {
  listID: string
  vesselInfo: VesselInfo[]
}

export function useFetchVesselsByList() {
  const request = useAxiosRequest()
  const [vesselInfoByList, setVesselInfoByList] = useState<VesselInfoByList[]>(
    []
  )
  const [isGetVesselsByListsLoading, setIsGetVesselsByListsLoading] =
    useState<boolean>(false)

  const getVesselsByList = async (listID: string[]) => {
    setIsGetVesselsByListsLoading(true)
    setVesselInfoByList([])

    try {
      const response = await request<any, VesselInfoByList[]>({
        url: `${BASE_URL}/vesseltracking/vessel/list`,
        method: "GET",
        params: { listID },
      })

      if (response?.data) {
        setVesselInfoByList(response.data)
      }
    } catch (err: unknown) {
      console.error("Failed to fetch vessel info by list:", err)
      if (axios.isAxiosError(err)) {
        toast.warn("Unable to fetch vessels grouped by list", {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setIsGetVesselsByListsLoading(false)
    }
  }

  return {
    vesselInfoByList,
    getVesselsByList,
    isGetVesselsByListsLoading,
  }
}
